import { filterHash } from "@fullcalendar/core/internal";
import React from "react";
import Select from "react-select";
const CommonModal = ({
  show,
  title,
  formFields = [],
  formData = {},
  onChange,
  onClose,
  onSubmit,
  submitText = "Save",
  extraContent,
  size = "lg"
}) => {
  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className={`modal-dialog modal-${size}`}>
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          {/* Body */}
          <div className="modal-body">

            <div className="row">
              {formFields.map((field, index) => {
                // SECTION TITLE
                if (field.type === "section") {
                  return (
                    <div className="col-12" key={index}>
                      <div className="form-section-title">{field.label}</div>
                    </div>
                  );
                }

                return (
                  <div className={`col-md-${field.col || 12}`} key={index}>
                    <div className="form-group" style={{ display: field.display || "block" }}>
                      <label className="form-label">
                        {field.label} {field.required && <span>*</span>}
                      </label>

                      {field.type === "textarea" ? (
                        <textarea
                          name={field.name}
                          className="form-control"
                          value={formData[field.name] || ""}
                          onChange={onChange}
                        />
                      ) : field.type === "select" ? (
                        <Select
                          name={field.name}
                          options={field.options}
                          value={field.options.find(
                            (opt) => String(opt.value) === String(formData[field.name])
                          ) || null}
                          onChange={(selected) =>
                            onChange({
                              target: {
                                name: field.name,
                                value: selected ? selected.value : "",
                              },
                            })
                          }
                          isDisabled={field.disabled}
                          isClearable
                        />
                      ) : field.type === "checkbox" ? (
                        <div>
                          <input
                            type="checkbox"
                            name={field.name}
                            checked={!!formData[field.name]}
                            onChange={(e) =>
                              onChange({
                                target: {
                                  name: field.name,
                                  value: e.target.checked,
                                },
                              })
                            }
                          />
                        </div>
                      ) : (
                        <input
                          type={field.type}
                          name={field.name}
                          className="form-control"
                          value={formData[field.name] || ""}
                          onChange={onChange}
                          onBlur={(e) => {
                            const value = e.target.value;

                            if (field.name.includes("weight") && value) {
                              onChange({
                                target: {
                                  name: field.name,
                                  value: parseFloat(value).toFixed(3),
                                },
                              });
                            }
                          }}
                          readOnly={field.readOnly}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            {extraContent && <div>{extraContent}</div>}
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            {onSubmit && (
              <button className="btn btn-primary" onClick={onSubmit}>
                {submitText}
              </button>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CommonModal;